import { render, staticRenderFns } from "./copyUserGroups.vue?vue&type=template&id=c7fd1d6e&scoped=true&"
import script from "./copyUserGroups.vue?vue&type=script&lang=js&"
export * from "./copyUserGroups.vue?vue&type=script&lang=js&"
import style0 from "./copyUserGroups.vue?vue&type=style&index=0&id=c7fd1d6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fd1d6e",
  null
  
)

export default component.exports